import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStatsRefresh } from '../../context/StatsRefreshContext';
import { streakService } from '../../api/streakService';
import { trackEvent } from '../../api/analyticsService';

const Challenge = () => {
    const { t } = useTranslation('statistics');
    const navigate = useNavigate();
    // overview and streak are fetched once in StatsRefreshContext and shared (Navigation reads
    // the same streak) — this widget never fetches either itself.
    const { overview, streak, setStreak, refreshStats } = useStatsRefresh();
    const streakDays = overview?.streak_days ?? null;
    const [buying, setBuying] = useState(false);

    // The real due count only. No fallback to daily_goal: while the overview is loading, or if
    // it failed, the line is left out rather than showing the goal as if words were waiting.
    const dueWords = overview?.review?.due_today;

    const buyFreeze = async () => {
        setBuying(true);
        try {
            setStreak(await streakService.buyFreeze());
            trackEvent('streak_freeze_bought', { source: 'challenge' });
        } catch {
            // Balance or max changed under us: refetch so the button state is right.
            refreshStats();
        } finally {
            setBuying(false);
        }
    };

    const canBuy = !!streak && streak.streak_freezes < streak.max_freezes && streak.xp_balance >= streak.freeze_cost;

    return (
        <div className="daily-challenge">
            <div className="challenge-top-row">
                <h3 className="challenge-title">{t('challenge.title')}</h3>
                {streakDays !== null && (
                    <div className="challenge-streak">
                        <span className="challenge-streak-icon">🔥</span>
                        <span className="challenge-streak-count">{streakDays}</span>
                    </div>
                )}
            </div>
            <p className="challenge-text">{t('challenge.focus')}</p>
            <p className="challenge-focus">{t('challenge.spaced_repetition')}</p>
            {dueWords !== undefined && (
                <p className="challenge-status">{t('challenge.due_words', { count: dueWords })}</p>
            )}
            {streak && streak.max_freezes > 0 && (
                <div className="challenge-freeze" title={t('challenge.freeze_hint')}>
                    <span className="challenge-freeze-count">
                        ❄️ {t('challenge.freezes', { n: streak.streak_freezes, max: streak.max_freezes })}
                    </span>
                    {streak.streak_freezes < streak.max_freezes && (
                        <button
                            className="challenge-freeze-buy"
                            onClick={buyFreeze}
                            disabled={!canBuy || buying}
                            title={canBuy ? undefined : t('challenge.freeze_need_xp', { cost: streak.freeze_cost, balance: streak.xp_balance })}
                        >
                            {t('challenge.freeze_buy', { cost: streak.freeze_cost })}
                        </button>
                    )}
                </div>
            )}
            <button className="challenge-button" onClick={() => navigate('/spaced-repetition')}>
                {t('challenge.start')}
            </button>
        </div>
    );
};

export default Challenge;
